export default __webpack_public_path__ + "static/media/TnB0475.6492278b.jpg";